import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=1163f1bf&scoped=true&"
import script from "./MenusList.vue?vue&type=script&lang=js&"
export * from "./MenusList.vue?vue&type=script&lang=js&"
import style0 from "./MenusList.vue?vue&type=style&index=0&id=1163f1bf&prod&lang=scss&scoped=true&"
import style1 from "./MenusList.vue?vue&type=style&index=1&id=1163f1bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163f1bf",
  null
  
)

export default component.exports